import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { t } from 'src/lib/language';
import { openModal } from 'src/redux/actions/modalActions';
import { MODALS } from 'src/models/ModalModel';

interface OwnProps {
  invoiceId: number,
}

type Props = OwnProps & ButtonProps;

const MakeRecurringButton = (props: Props) => {
  const { disabled, invoiceId } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const handleOpen = () => {
    dispatch(openModal({
      modal: MODALS.addRecurring,
      payload: { sourceInvoiceId: invoiceId },
    }));
  };

  return (
    <>
      <Tooltip
        title={t(lang, 'menus.make_recurring')}
        placement="top-start">
        <span>
          <ActionButton
            variant="outlined"
            category={MENU_BUTTON_CATEGORY.action}
            onClick={handleOpen}
            disabled={disabled}>
            <AutorenewIcon />
          </ActionButton>
        </span>
      </Tooltip>
    </>
  );
};

export default MakeRecurringButton;
